import { AnyAction } from 'redux';
import captureBreadcrumb from './captureBreadcrumb';

const maxValueLength = 100;

function shortenValue<Value>(value: Value): Value | string {
	if (value instanceof Promise) {
		return '[promise]';
	}
	if (value !== null && typeof value === 'object') {
		let stringValue = '';
		try {
			stringValue = JSON.stringify(value);
		} catch (error) {
			stringValue = '[error: not-serializable object]';
		}
		const shortValue = stringValue.slice(0, maxValueLength);
		return stringValue.length !== shortValue.length ? `${shortValue}…` : shortValue;
	}
	return value;
}

export default function reduxLoggingMiddleware() {
	return <Action extends { type: string }>(next: (action: AnyAction) => any) =>
		(action: Action) => {
			const actionKeys = Object.keys(action) as (keyof Action)[];

			const data = actionKeys.reduce((data: { [key in keyof Action]: string }, key: keyof Action) => {
				if (key !== 'type') {
					return {
						...data,
						[key]: shortenValue(action[key]),
					};
				}

				return data;
			}, {} as { [key in keyof Action]: string });

			captureBreadcrumb({
				message: action.type,
				category: 'redux',
				data,
			});
			return next(action);
		};
}
